import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DsFormsModule, DsIconModule, SelectListOption } from '@bmw-ds/components';

import { SelectFieldComponent } from '../select-field/select-field.component';

@Component({
  selector: 'cdf-language-picker',
  imports: [DsFormsModule, FormsModule, DsIconModule, SelectFieldComponent],
  host: { class: 'd-flex' },
  template: `
    <cdf-select-field
      id="correspondence-language"
      [options]="languagePickerOptions()"
      [(model)]="language"
      [displayError]="displayError()"
      [errorMessage]="errorMessage()"
      [disabled]="disabled()"
      [label]="label()"
      [inlineConfig]="{ labelWidth: 'min-width', inputWidth: 'var(--ds-shape-size-xmin-input)' }"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguagePickerComponent {
  readonly label = input.required<string>();
  readonly languages = input.required<string[]>();
  readonly disabled = input(false);
  readonly language = model.required<string>();
  readonly displayError = input(false);
  readonly errorMessage = input<string>();

  protected readonly languagePickerOptions = computed(() =>
    this.languages().map(
      (language): SelectListOption => ({
        id: language,
        label: language.toUpperCase(),
      }),
    ),
  );
}
